export const useCurrentYearStore = defineStore('currentYear', () => {
    const currentYear = ref<any>({})

    const fetchCurrentYear = async (locale: string, apiFetch: any) => {
        const response = await apiFetch(`/${locale}/api/site/fair-years/current/`)
        currentYear.value = response
    }

    return { currentYear, fetchCurrentYear }
})